<div class="search-bar-container">
  <div class="search-bar search-bar--phase3">
    <svg class="search-icon search-icon--leading" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
      <circle cx="11" cy="11" r="8"></circle>
      <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
    </svg>
    <input type="text"
           class="ts-search-input"
           placeholder="Search Truth Shorts"
           [(ngModel)]="searchQuery"
           (input)="onSearch(searchQuery)"
           autocomplete="off" />
  </div>

  <div class="search-results-container" *ngIf="hasSearchResults && searchQuery?.trim()">
    <div *ngIf="postResults.length > 0">
      <h3>Posts</h3>
      <div *ngFor="let post of postResults" (click)="goToSearch(post.MatchedText)">
        <div class="post-result">
          <p *ngIf="post.MatchedText?.trim(); else noMatchText">
            <svg class="search-icon" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <circle cx="11" cy="11" r="8"></circle>
              <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
            </svg>
            {{ post.MatchedText }}
          </p>
          <ng-template #noMatchText>
            <p>No match found.</p>
          </ng-template>
        </div>
      </div>
    </div>

    <hr *ngIf="postResults.length > 0 && userResults.length > 0"/>

    <div *ngIf="userResults.length > 0">
      <h3>Users</h3>
      <div *ngFor="let user of userResults">
        <div class="user-result" (click)="goToUser(user.UserName)">
          <img [src]="user.UserImg" alt="{{ user.UserName }}" class="user-img"/>
          <div>
            <h5>{{ user.ProfileName }}</h5>
            &#64;{{ user.UserName }}
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
